// src/pages/ingresos/components/AssignTechnicianModal.jsx
import React from "react";

export default function AssignTechnicianModal({
  assigning,
  techs,
  selectedTech,
  setSelectedTech,
  onClose,
  onAssign,
}) {
  if (!assigning.poId) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
      <div className="w-full max-w-md rounded-lg border border-slate-700 bg-slate-900 p-4">
        <h3 className="text-lg font-semibold mb-3">
          Asignar técnico a la OS
        </h3>

        <select
          className="w-full rounded-md border bg-background px-3 py-2 text-sm mb-4"
          value={selectedTech}
          onChange={(e) => setSelectedTech(e.target.value)}
        >
          <option value="">Seleccionar técnico…</option>
          {techs.map((t) => (
            <option key={t.id} value={t.id}>
              {t.full_name}
            </option>
          ))}
        </select>

        <div className="flex justify-end gap-2">
          <button
            className="rounded border border-slate-600/60 px-3 py-1 text-slate-300 hover:bg-slate-600/10"
            onClick={onClose}
            disabled={assigning.saving}
          >
            Cancelar
          </button>
          <button
            className="rounded border border-emerald-600/60 px-3 py-1 text-emerald-300 hover:bg-emerald-600/10"
            onClick={onAssign}
            disabled={!selectedTech || assigning.saving}
            title="Asigna todas las OS de esta orden al técnico seleccionado"
          >
            {assigning.saving ? "Asignando…" : "Asignar técnico"}
          </button>
        </div>
      </div>
    </div>
  );
}